import './App.css';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WorksSection from './components/WorksSection';
import BlogSection from './components/BlogSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-[#0d0e18] text-white font-IBM">
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <WorksSection />
      <BlogSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
